import React from 'react';
import { Redirect } from "react-router-dom";

import SingleNextButton from '../Atoms/SingleNextButton';
import Form from '../StepComponents/Form';
import StepShell from '../StepComponents/StepShell';
import SelectField from '../Molecules/SelectField';
import { setApp, getApp } from '../../index';
import { isCurrentMember } from '../../Utils/SelectOptions';
import checkPromo from '../../Api/checkPromoCodeApi';

class StepMemberEligibility extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            notFound: false,
            nxtUrl: '',
            hasChanged: false
        }
    }

    parseURL() {
        // Based on the #tag on the URL, set product name for this application
        var hash = window.location.hash;

        // If there's #tag on URL, try to parse it to get product 
        if (hash) {
            var hashless = hash.replace('#', '');
            var urlParams = hashless.split('&');
            var find = "_";
            var regex = new RegExp(find, "g");
            var product = urlParams[0].replace(regex, " ");
            var promoCode = urlParams[1];

            product = product.toLowerCase()
                .split(' ')
                .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                .join(' ');

            if (product === "Connect Rewards Visa Signature" || product === "Connect Visa") {
                setApp('product', product);

                if (promoCode) {
                    checkPromo(promoCode);
                }

            } else {
                // if #tag is not either two of the visa products we provide, set notFound to true. This will cause page to redirect to NotFound Page
                // this.state.notFound = true;
                this.setState({
                    notFound: true
                });
            }
        }
    }

    handleChange(value) {
        this.setState({ hasChanged: true });

        if (value === "true") {
            this.setState({ nxtUrl: '/loan-application/identity' });
        } else {
            this.setState({ nxtUrl: '/loan-application/eligibility' });
        }
    }

    render() {
        this.parseURL();
        // Get Product from state
        // If there's no #tag, try to lookup state and see if there's any product which was specified
        let existingProduct = getApp('product');
        let url = '';

        if (this.setState.hasChanged) {
            url = this.state.nxtUrl;
        } else {
            if (getApp('currentMember') === "true") {
                url = '/loan-application/identity';
            } else {
                url = '/loan-application/eligibility';
            }
        }

        return (
            <StepShell
                stepID="StepMemberEligibility"
                friendlyText={`Interested in the ${existingProduct ? existingProduct : "Unknown Product"}? Let’s get started with this simple application.`}
                requestText="Membership is required in order to receive this credit card. Are you a current Member of Vantage West?"
                progress="5%"
                progressLabel="Membership"
                backLink="/"
            >

                {this.state.notFound && (
                    <Redirect to="/loan-application/not-found" />
                )}
                <Form nextLink={url}>
                    <input name="product" type="hidden" val={`${existingProduct}`} />
                    <SelectField options={isCurrentMember} required={true} name="currentMember" placeholder="Have Membership with Vantage West?" labelType="hidden"
                        handleChange={this.handleChange.bind(this)}
                    />
                    <SingleNextButton nextBtnTxt="next" />

                </Form>

            </StepShell>
        )
    }
}

export default StepMemberEligibility;
